// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file reports/product_profitability_report.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ProductProfitabilityItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ProductProfitabilityReportRequest
 */
export class ProductProfitabilityReportRequest extends Message<ProductProfitabilityReportRequest> {
  /**
   * Page number for pagination
   *
   * @generated from field: int32 page_number = 1;
   */
  pageNumber = 0;

  /**
   * Number of records per page
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<ProductProfitabilityReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ProductProfitabilityReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProductProfitabilityReportRequest {
    return new ProductProfitabilityReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProductProfitabilityReportRequest {
    return new ProductProfitabilityReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProductProfitabilityReportRequest {
    return new ProductProfitabilityReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ProductProfitabilityReportRequest | PlainMessage<ProductProfitabilityReportRequest> | undefined, b: ProductProfitabilityReportRequest | PlainMessage<ProductProfitabilityReportRequest> | undefined): boolean {
    return proto3.util.equals(ProductProfitabilityReportRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ProductProfitabilityReportResponse
 */
export class ProductProfitabilityReportResponse extends Message<ProductProfitabilityReportResponse> {
  /**
   * List of supplier profitability items
   *
   * @generated from field: repeated com.neulink.pharmacy.ProductProfitabilityItem product_profitability_items = 1;
   */
  productProfitabilityItems: ProductProfitabilityItem[] = [];

  /**
   * Total number of items available
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<ProductProfitabilityReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ProductProfitabilityReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "product_profitability_items", kind: "message", T: ProductProfitabilityItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProductProfitabilityReportResponse {
    return new ProductProfitabilityReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProductProfitabilityReportResponse {
    return new ProductProfitabilityReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProductProfitabilityReportResponse {
    return new ProductProfitabilityReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ProductProfitabilityReportResponse | PlainMessage<ProductProfitabilityReportResponse> | undefined, b: ProductProfitabilityReportResponse | PlainMessage<ProductProfitabilityReportResponse> | undefined): boolean {
    return proto3.util.equals(ProductProfitabilityReportResponse, a, b);
  }
}

